import { Screen } from '../components/Screen'

export function LoadingScreen({ label, onClose }: { label: string; onClose?: () => void }) {
  return (
    <Screen onClose={onClose}>
      <div className="flex flex-col items-center gap-4 py-6">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-slate-200 border-t-brand" />
        <p className="text-slate-600">{label}</p>
      </div>
    </Screen>
  )
}
